import elementFactory from './factory';
import size, { SIZE } from '../props/size';
import position, { POSITION } from '../props/position';

/**
 * Парсер елемента side-element
 * @see https://github.yandex-team.ru/portal/morda-schema/blob/master/api/search/2/div/div-universal-block.json
 * @param  {Object} sideElement
 * @return {Object}
 */
export default (function (sideElement) {
    if (!sideElement) {
        return null;
    }

    var element = elementFactory(sideElement.element);

    if (!element) {
        return null;
    }

    return {
        element: element,
        size: size(sideElement.size, SIZE.s),
        position: position(sideElement.position, POSITION.left),
        weight: element.weight
    };
});